import React from 'react';
import { useGetNayaxMdbTemplatesQuery } from 'data/__generated__';
import { TotemSelect } from 'components/TotemSelect';

interface NayaxMDBTemplateSelectProps {
    value: string | null;
    onChange: (value: string | null) => void;
}

export const NayaxMDBTemplateSelect: React.FC<NayaxMDBTemplateSelectProps> = ({ value, onChange }) => {
    const { data: templatesData, loading } = useGetNayaxMdbTemplatesQuery();

    const options = React.useMemo(
        () =>
            (templatesData?.nayaxMDBTemplates || []).map((template) => ({
                label: template.name,
                value: template._id,
            })),
        [templatesData],
    );

    return (
        <TotemSelect
            label="Choisir un template MDB"
            placeholder="template MDB"
            value={value}
            options={options}
            onChange={onChange}
            disabled={loading}
        />
    );
};
